const integer = '[-]?[\\d]{1,9}';

const decimal = '[-]?[\\d]{1,28}([.][\\d]{1,27})?';

const unixTime = '[\\d]{1,18}';

const isoDate = '([1-9][0-9]{3})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])';

const time = '([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])';

const fiveMileseconds = '([0-9][0-9][0-9][0-9][0-9])';

const sixMileseconds = '([0-9][0-9][0-9][0-9][0-9][0-9])';

const sevenMileseconds = '([0-9]{7})';
const eightMileseconds = '([0-9]{8})';
const nineMileseconds = '([0-9]{9})';

const sixSecurityDateTime = isoDate + 'T' + time + '.' + fiveMileseconds + 'Z';

const mifirTransparencyDateTime = isoDate + 'T' + time + '.' + sixMileseconds + 'Z';

const isoDateTime = isoDate + 'T' + time + 'Z';

const setupPattern = (pattern: string): string => '^' + pattern + '$';

const catDateTime = isoDate + 'T' + time + '.' + sevenMileseconds + 'Z';

const xtxDateTime1 = 'd' + isoDate + ' ' + time + '.' + sevenMileseconds + 'Z';
const xtxDateTime2 = 'd' + isoDate + ' ' + time + '.' + eightMileseconds + 'Z';
const xtxDateTime3 = 'd' + isoDate + ' ' + time + '.' + nineMileseconds + 'Z';

const regexPattern = {
    integer: new RegExp(setupPattern(integer)),

    decimal: new RegExp(setupPattern(decimal)),

    unixTime: new RegExp(setupPattern(unixTime)),

    isoDate: new RegExp(setupPattern(isoDate)),

    time: new RegExp(setupPattern(time)),

    isoDateTime: new RegExp(setupPattern(isoDateTime)),

    sixSecurityDateTime: new RegExp(setupPattern(sixSecurityDateTime)),

    mifirTransparencyDateTime: new RegExp(setupPattern(mifirTransparencyDateTime)),

    catDateTime: new RegExp(setupPattern(catDateTime)),

    xtxDateTime1: new RegExp(setupPattern(xtxDateTime1)),

    xtxDateTime2: new RegExp(setupPattern(xtxDateTime2)),

    xtxDateTime3: new RegExp(setupPattern(xtxDateTime3)),
};

export default regexPattern;
